const shredieckNotes = [
  '4A','4B','5Cn','5D','5E','5D','5C','4B',
  '4A','4B','5C','5D','5E','5D','5C','4B',
  '4A','4B','5C','5D','5E','5D','5C','4B',
  '4A','4B','5C','5D','5E','5D','5C','4B',

  '4A','4B','5C','5D','5C','5D','5C','5D',
  '5C','5D','5C','5D','5C','5D','5C','4A',
  '4B','5C','5D','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5D','5E','5D','4B',

  '5C','4B','5C','5D','5E','5D','5E','5D',
  '5E','5D','5E','5D','5E','5D','5E','5C',
  '4B','4A','4B','5C','5D','5C','5D','5C',
  '5D','5C','5D','5C','5D','5C','5D','4B',

  '5C','5D','5C','4B','4A','4B','4A','4B',
  '4A','4B','4A','4B','4A','4B','4A','5C',
  '5D','5E','5D','5C','4B','5C','4B','5C',
  '4B','5C','4B','5C','4B','5C','4B','5D',

  '5C','4A','5C','4A','4B','4A','4B','4A',
  '5C','4A','5C','4A','5D','4A','5D','4A',
  '4B','4A','4B','4A','5C','4A','5C','4A',
  '5D','4A','5D','4A','4B','4A','4B','4A',

  '5C','5E','5C','5E','4B','5E','4B','5E',
  '5C','5E','5C','5E','5D','5E','5D','5E',
  '4B','5E','4B','5E','5C','5E','5C','5E',
  '5D','5E','5D','5E','4B','5E','4B','5E',

  '5C','5E','5C','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5C','5E','5C','5E',
  '4B','5E','4B','5E','5C','5E','5C','5E',
  '5C','5E','5C','5E','4B','5E','4B','5E',

  '4A','5E','4A','5E','4B','5E','4B','5E',
  '4B','5E','4B','5E','4A','5E','4A','5E',
  '4B','5E','4B','5E','5C','5E','5C','5E',
  '5C','5E','5C','5E','4B','5E','4B','5E',

  '4A','5E','5D','5C','4B','5C','5D','5E',
  '5C','5E','5D','5C','4B','5C','5D','5E',
  '5C','5E','5D','5C','4B','5C','5D','5E',
  '5C','5E','5D','5C','4B','5C','5D','5E',

  '5C','4A','4B','5C','5D','4B','5C','5D',
  '5E','4A','4B','5C','5D','4B','5C','5D',
  '5E','4A','4B','5C','5D','4B','5C','5D',
  '5E','4A','4B','5C','5D','4B','5C','5D',

  '5E','5D','5C','5E','5D','5C','5D','5C',
  '5D','5C','4B','5D','5C','4B','5C','4B',
  '5C','4B','4A','5C','4B','4A','4B','4A',
  '5D','5C','4B','5D','5C','4B','5C','4B',

  '5C','5D','5E','5D','5C','5D','5C','5D',
  '4B','5C','5D','5C','4B','5C','4B','5C',
  '4A','4B','5C','4B','4A','4B','4A','5C',
  '4B','5C','5D','5C','4B','5C','4B','5D',


  //1
  '4A','4B','5Cs','5D','5E','5D','5Cs','4B',
  '4A','4B','5Cs','5D','5E','5D','5Cs','4B',
  '4A','4B','5Cs','5D','5E','5D','5Cs','4B',
  '4A','4B','5Cs','5D','5E','5D','5Cs','4B',

  '4A','4B','5Cs','5D','5Cs','5D','5Cs','5D',
  '5Cs','5D','5Cs','5D','5Cs','5D','5Cs','4A',
  '4B','5Cs','5D','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5D','5E','5D','4B',

  '5Cs','4B','5Cs','5D','5E','5D','5E','5D',
  '5E','5D','5E','5D','5E','5D','5E','5Cs',
  '4B','4A','4B','5Cs','5D','5Cs','5D','5Cs',
  '5D','5Cs','5D','5Cs','5D','5Cs','5D','4B',

  '5Cs','5D','5Cs','4B','4A','4B','4A','4B',
  '4A','4B','4A','4B','4A','4B','4A','5Cs',
  '5D','5E','5D','5Cs','4B','5Cs','4B','5Cs',
  '4B','5Cs','4B','5Cs','4B','5Cs','4B','5D',

  '5Cs','4A','5Cs','4A','4B','4A','4B','4A',
  '5Cs','4A','5Cs','4A','5D','4A','5D','4A',
  '4B','4A','4B','4A','5Cs','4A','5Cs','4A',
  '5D','4A','5D','4A','4B','4A','4B','4A',

  '5Cs','5E','5Cs','5E','4B','5E','4B','5E',
  '5Cs','5E','5Cs','5E','5D','5E','5D','5E',
  '4B','5E','4B','5E','5Cs','5E','5Cs','5E',
  '5D','5E','5D','5E','4B','5E','4B','5E',

  '5Cs','5E','5Cs','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5Cs','5E','5Cs','5E',
  '4B','5E','4B','5E','5Cs','5E','5Cs','5E',
  '5Cs','5E','5Cs','5E','4B','5E','4B','5E',

  '4A','5E','4A','5E','4B','5E','4B','5E',
  '4B','5E','4B','5E','4A','5E','4A','5E',
  '4B','5E','4B','5E','5Cs','5E','5Cs','5E',
  '5Cs','5E','5Cs','5E','4B','5E','4B','5E',

  '4A','5E','5D','5Cs','4B','5Cs','5D','5E',
  '5Cs','5E','5D','5Cs','4B','5Cs','5D','5E',
  '5Cs','5E','5D','5Cs','4B','5Cs','5D','5E',
  '5Cs','5E','5D','5Cs','4B','5Cs','5D','5E',

  '5Cs','4A','4B','5Cs','5D','4B','5Cs','5D',
  '5E','4A','4B','5Cs','5D','4B','5Cs','5D',
  '5E','4A','4B','5Cs','5D','4B','5Cs','5D',
  '5E','4A','4B','5Cs','5D','4B','5Cs','5D',

  '5E','5D','5Cs','5E','5D','5Cs','5D','5Cs',
  '5D','5Cs','4B','5D','5Cs','4B','5Cs','4B',
  '5Cs','4B','4A','5Cs','4B','4A','4B','4A',
  '5D','5Cs','4B','5D','5Cs','4B','5Cs','4B',

  '5Cs','5D','5E','5D','5Cs','5D','5Cs','5D',
  '4B','5Cs','5D','5Cs','4B','5Cs','4B','5Cs',
  '4A','4B','5Cs','4B','4A','4B','4A','5Cs',
  '4B','5Cs','5D','5Cs','4B','5Cs','4B','5D',

    //2
  '4A','4B','5Cs','5Ds','5E','5Ds','5Cs','4B',
  '4A','4B','5Cs','5Ds','5E','5Ds','5Cs','4B',
  '4A','4B','5Cs','5Ds','5E','5Ds','5Cs','4B',
  '4A','4B','5Cs','5Ds','5E','5Ds','5Cs','4B',

  '4A','4B','5Cs','5Ds','5Cs','5Ds','5Cs','5Ds',
  '5Cs','5Ds','5Cs','5Ds','5Cs','5Ds','5Cs','4A',
  '4B','5Cs','5Ds','5E','5Ds','5E','5Ds','5E',
  '5Ds','5E','5Ds','5E','5Ds','5E','5Ds','4B',

  '5Cs','4B','5Cs','5Ds','5E','5Ds','5E','5Ds',
  '5E','5Ds','5E','5Ds','5E','5Ds','5E','5Cs',
  '4B','4A','4B','5Cs','5Ds','5Cs','5Ds','5Cs',
  '5Ds','5Cs','5Ds','5Cs','5Ds','5Cs','5Ds','4B',

  '5Cs','5Ds','5Cs','4B','4A','4B','4A','4B',
  '4A','4B','4A','4B','4A','4B','4A','5Cs',
  '5Ds','5E','5Ds','5Cs','4B','5Cs','4B','5Cs',
  '4B','5Cs','4B','5Cs','4B','5Cs','4B','5Ds',

  '5Cs','4A','5Cs','4A','4B','4A','4B','4A',
  '5Cs','4A','5Cs','4A','5Ds','4A','5Ds','4A',
  '4B','4A','4B','4A','5Cs','4A','5Cs','4A',
  '5Ds','4A','5Ds','4A','4B','4A','4B','4A',

  '5Cs','5E','5Cs','5E','4B','5E','4B','5E',
  '5Cs','5E','5Cs','5E','5Ds','5E','5Ds','5E',
  '4B','5E','4B','5E','5Cs','5E','5Cs','5E',
  '5Ds','5E','5Ds','5E','4B','5E','4B','5E',

  '5Cs','5E','5Cs','5E','5Ds','5E','5Ds','5E',
  '5Ds','5E','5Ds','5E','5Cs','5E','5Cs','5E',
  '4B','5E','4B','5E','5Cs','5E','5Cs','5E',
  '5Cs','5E','5Cs','5E','4B','5E','4B','5E',

  '4A','5E','4A','5E','4B','5E','4B','5E',
  '4B','5E','4B','5E','4A','5E','4A','5E',
  '4B','5E','4B','5E','5Cs','5E','5Cs','5E',
  '5Cs','5E','5Cs','5E','4B','5E','4B','5E',

  '4A','5E','5Ds','5Cs','4B','5Cs','5Ds','5E',
  '5Cs','5E','5Ds','5Cs','4B','5Cs','5Ds','5E',
  '5Cs','5E','5Ds','5Cs','4B','5Cs','5Ds','5E',
  '5Cs','5E','5Ds','5Cs','4B','5Cs','5Ds','5E',

  '5Cs','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',
  '5E','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',
  '5E','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',
  '5E','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',

  '5E','5Ds','5Cs','5E','5Ds','5Cs','5Ds','5Cs',
  '5Ds','5Cs','4B','5Ds','5Cs','4B','5Cs','4B',
  '5Cs','4B','4A','5Cs','4B','4A','4B','4A',
  '5Ds','5Cs','4B','5Ds','5Cs','4B','5Cs','4B',

  '5Cs','5Ds','5E','5Ds','5Cs','5Ds','5Cs','5Ds',
  '4B','5Cs','5Ds','5Cs','4B','5Cs','4B','5Cs',
  '4A','4B','5Cs','4B','4A','4B','4A','5Cs',
  '4B','5Cs','5Ds','5Cs','4B','5Cs','4B','5Ds',
  //3
  '4A','4B','5Cs','5Ds','5Es','5Ds','5Cs','4B',
  '4A','4B','5Cs','5Ds','5Es','5Ds','5Cs','4B',
  '4A','4B','5Cs','5Ds','5Es','5Ds','5Cs','4B',
  '4A','4B','5Cs','5Ds','5Es','5Ds','5Cs','4B',

  '4A','4B','5Cs','5Ds','5Cs','5Ds','5Cs','5Ds',
  '5Cs','5Ds','5Cs','5Ds','5Cs','5Ds','5Cs','4A',
  '4B','5Cs','5Ds','5Es','5Ds','5Es','5Ds','5Es',
  '5Ds','5Es','5Ds','5Es','5Ds','5Es','5Ds','4B',

  '5Cs','4B','5Cs','5Ds','5Es','5Ds','5Es','5Ds',
  '5Es','5Ds','5Es','5Ds','5Es','5Ds','5Es','5Cs',
  '4B','4A','4B','5Cs','5Ds','5Cs','5Ds','5Cs',
  '5Ds','5Cs','5Ds','5Cs','5Ds','5Cs','5Ds','4B',

  '5Cs','5Ds','5Cs','4B','4A','4B','4A','4B',
  '4A','4B','4A','4B','4A','4B','4A','5Cs',
  '5Ds','5Es','5Ds','5Cs','4B','5Cs','4B','5Cs',
  '4B','5Cs','4B','5Cs','4B','5Cs','4B','5Ds',

  '5Cs','4A','5Cs','4A','4B','4A','4B','4A',
  '5Cs','4A','5Cs','4A','5Ds','4A','5Ds','4A',
  '4B','4A','4B','4A','5Cs','4A','5Cs','4A',
  '5Ds','4A','5Ds','4A','4B','4A','4B','4A',

  '5Cs','5Es','5Cs','5Es','4B','5Es','4B','5Es',
  '5Cs','5Es','5Cs','5Es','5Ds','5Es','5Ds','5Es',
  '4B','5Es','4B','5Es','5Cs','5Es','5Cs','5Es',
  '5Ds','5Es','5Ds','5Es','4B','5Es','4B','5Es',

  '5Cs','5Es','5Cs','5Es','5Ds','5Es','5Ds','5Es',
  '5Ds','5Es','5Ds','5Es','5Cs','5Es','5Cs','5Es',
  '4B','5Es','4B','5Es','5Cs','5Es','5Cs','5Es',
  '5Cs','5Es','5Cs','5Es','4B','5Es','4B','5Es',

  '4A','5Es','4A','5Es','4B','5Es','4B','5Es',
  '4B','5Es','4B','5Es','4A','5Es','4A','5Es',
  '4B','5Es','4B','5Es','5Cs','5Es','5Cs','5Es',
  '5Cs','5Es','5Cs','5Es','4B','5Es','4B','5Es',

  '4A','5Es','5Ds','5Cs','4B','5Cs','5Ds','5Es',
  '5Cs','5Es','5Ds','5Cs','4B','5Cs','5Ds','5Es',
  '5Cs','5Es','5Ds','5Cs','4B','5Cs','5Ds','5Es',
  '5Cs','5Es','5Ds','5Cs','4B','5Cs','5Ds','5Es',

  '5Cs','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',
  '5Es','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',
  '5Es','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',
  '5Es','4A','4B','5Cs','5Ds','4B','5Cs','5Ds',

  '5Es','5Ds','5Cs','5Es','5Ds','5Cs','5Ds','5Cs',
  '5Ds','5Cs','4B','5Ds','5Cs','4B','5Cs','4B',
  '5Cs','4B','4A','5Cs','4B','4A','4B','4A',
  '5Ds','5Cs','4B','5Ds','5Cs','4B','5Cs','4B',

  '5Cs','5Ds','5Es','5Ds','5Cs','5Ds','5Cs','5Ds',
  '4B','5Cs','5Ds','5Cs','4B','5Cs','4B','5Cs',
  '4A','4B','5Cs','4B','4A','4B','4A','5Cs',
  '4B','5Cs','5Ds','5Cs','4B','5Cs','4B','5Ds',

//4
  '4A','5C','5Db','5Eb','5F','5Eb','5Db','5C',
  '4A','5C','5Db','5Eb','5F','5Eb','5Db','5C',
  '4A','5C','5Db','5Eb','5F','5Eb','5Db','5C',
  '4A','5C','5Db','5Eb','5F','5Eb','5Db','5C',

  '4A','5C','5Db','5Eb','5Db','5Eb','5Db','5Eb',
  '5Db','5Eb','5Db','5Eb','5Db','5Eb','5Db','4A',
  '5C','5Db','5Eb','5F','5Eb','5F','5Eb','5F',
  '5Eb','5F','5Eb','5F','5Eb','5F','5Eb','5C',

  '5Db','5C','5Db','5Eb','5F','5Eb','5F','5Eb',
  '5F','5Eb','5F','5Eb','5F','5Eb','5F','5Db',
  '5C','4A','5C','5Db','5Eb','5Db','5Eb','5Db',
  '5Eb','5Db','5Eb','5Db','5Eb','5Db','5Eb','5C',

  '5Db','5Eb','5Db','5C','4A','5C','4A','5C',
  '4A','5C','4A','5C','4A','5C','4A','5Db',
  '5Eb','5F','5Eb','5Db','5C','5Db','5C','5Db',
  '5C','5Db','5C','5Db','5C','5Db','5C','5Eb',

  '5Db','4A','5Db','4A','5C','4A','5C','4A',
  '5Db','4A','5Db','4A','5Eb','4A','5Eb','4A',
  '5C','4A','5C','4A','5Db','4A','5Db','4A',
  '5Eb','4A','5Eb','4A','5C','4A','5C','4A',

  '5Db','5F','5Db','5F','5C','5F','5C','5F',
  '5Db','5F','5Db','5F','5Eb','5F','5Eb','5F',
  '5C','5F','5C','5F','5Db','5F','5Db','5F',
  '5Eb','5F','5Eb','5F','5C','5F','5C','5F',

  '5Db','5F','5Db','5F','5Eb','5F','5Eb','5F',
  '5Eb','5F','5Eb','5F','5Db','5F','5Db','5F',
  '5C','5F','5C','5F','5Db','5F','5Db','5F',
  '5Db','5F','5Db','5F','5C','5F','5C','5F',

  '4A','5F','4A','5F','5C','5F','5C','5F',
  '5C','5F','5C','5F','4A','5F','4A','5F',
  '5C','5F','5C','5F','5Db','5F','5Db','5F',
  '5Db','5F','5Db','5F','5C','5F','5C','5F',

  '4A','5F','5Eb','5Db','5C','5Db','5Eb','5F',
  '5Db','5F','5Eb','5Db','5C','5Db','5Eb','5F',
  '5Db','5F','5Eb','5Db','5C','5Db','5Eb','5F',
  '5Db','5F','5Eb','5Db','5C','5Db','5Eb','5F',

  '5Db','4A','5C','5Db','5Eb','5C','5Db','5Eb',
  '5F','4A','5C','5Db','5Eb','5C','5Db','5Eb',
  '5F','4A','5C','5Db','5Eb','5C','5Db','5Eb',
  '5F','4A','5C','5Db','5Eb','5C','5Db','5Eb',

  '5F','5Eb','5Db','5F','5Eb','5Db','5Eb','5Db',
  '5Eb','5Db','5C','5Eb','5Db','5C','5Db','5C',
  '5Db','5C','4A','5Db','5C','4A','5C','4A',
  '5Eb','5Db','5C','5Eb','5Db','5C','5Db','5C',

  '5Db','5Eb','5F','5Eb','5Db','5Eb','5Db','5Eb',
  '5C','5Db','5Eb','5Db','5C','5Db','5C','5Db',
  '4A','5C','5Db','5C','4A','5C','4A','5Db',
  '5C','5Db','5Eb','5Db','5C','5Db','5C','5Eb',

//5
  '4A','5C','5D','5Eb','5F','5Eb','5D','5C',
  '4A','5C','5D','5Eb','5F','5Eb','5D','5C',
  '4A','5C','5D','5Eb','5F','5Eb','5D','5C',
  '4A','5C','5D','5Eb','5F','5Eb','5D','5C',

  '4A','5C','5D','5Eb','5D','5Eb','5D','5Eb',
  '5D','5Eb','5D','5Eb','5D','5Eb','5D','4A',
  '5C','5D','5Eb','5F','5Eb','5F','5Eb','5F',
  '5Eb','5F','5Eb','5F','5Eb','5F','5Eb','5C',

  '5D','5C','5D','5Eb','5F','5Eb','5F','5Eb',
  '5F','5Eb','5F','5Eb','5F','5Eb','5F','5D',
  '5C','4A','5C','5D','5Eb','5D','5Eb','5D',
  '5Eb','5D','5Eb','5D','5Eb','5D','5Eb','5C',

  '5D','5Eb','5D','5C','4A','5C','4A','5C',
  '4A','5C','4A','5C','4A','5C','4A','5D',
  '5Eb','5F','5Eb','5D','5C','5D','5C','5D',
  '5C','5D','5C','5D','5C','5D','5C','5Eb',

  '5D','4A','5D','4A','5C','4A','5C','4A',
  '5D','4A','5D','4A','5Eb','4A','5Eb','4A',
  '5C','4A','5C','4A','5D','4A','5D','4A',
  '5Eb','4A','5Eb','4A','5C','4A','5C','4A',

  '5D','5F','5D','5F','5C','5F','5C','5F',
  '5D','5F','5D','5F','5Eb','5F','5Eb','5F',
  '5C','5F','5C','5F','5D','5F','5D','5F',
  '5Eb','5F','5Eb','5F','5C','5F','5C','5F',

  '5D','5F','5D','5F','5Eb','5F','5Eb','5F',
  '5Eb','5F','5Eb','5F','5D','5F','5D','5F',
  '5C','5F','5C','5F','5D','5F','5D','5F',
  '5D','5F','5D','5F','5C','5F','5C','5F',

  '4A','5F','4A','5F','5C','5F','5C','5F',
  '5C','5F','5C','5F','4A','5F','4A','5F',
  '5C','5F','5C','5F','5D','5F','5D','5F',
  '5D','5F','5D','5F','5C','5F','5C','5F',

  '4A','5F','5Eb','5D','5C','5D','5Eb','5F',
  '5D','5F','5Eb','5D','5C','5D','5Eb','5F',
  '5D','5F','5Eb','5D','5C','5D','5Eb','5F',
  '5D','5F','5Eb','5D','5C','5D','5Eb','5F',

  '5D','4A','5C','5D','5Eb','5C','5D','5Eb',
  '5F','4A','5C','5D','5Eb','5C','5D','5Eb',
  '5F','4A','5C','5D','5Eb','5C','5D','5Eb',
  '5F','4A','5C','5D','5Eb','5C','5D','5Eb',

  '5F','5Eb','5D','5F','5Eb','5D','5Eb','5D',
  '5Eb','5D','5C','5Eb','5D','5C','5D','5C',
  '5D','5C','4A','5D','5C','4A','5C','4A',
  '5Eb','5D','5C','5Eb','5D','5C','5D','5C',

  '5D','5Eb','5F','5Eb','5D','5Eb','5D','5Eb',
  '5C','5D','5Eb','5D','5C','5D','5C','5D',
  '4A','5C','5D','5C','4A','5C','4A','5D',
  '5C','5D','5Eb','5D','5C','5D','5C','5Eb',

  //6
  '4A','5C','5D','5E','5F','5E','5D','5C',
  '4A','5C','5D','5E','5F','5E','5D','5C',
  '4A','5C','5D','5E','5F','5E','5D','5C',
  '4A','5C','5D','5E','5F','5E','5D','5C',

  '4A','5C','5D','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5D','5E','5D','4A',
  '5C','5D','5E','5F','5E','5F','5E','5F',
  '5E','5F','5E','5F','5E','5F','5E','5C',

  '5D','5C','5D','5E','5F','5E','5F','5E',
  '5F','5E','5F','5E','5F','5E','5F','5D',
  '5C','4A','5C','5D','5E','5D','5E','5D',
  '5E','5D','5E','5D','5E','5D','5E','5C',

  '5D','5E','5D','5C','4A','5C','4A','5C',
  '4A','5C','4A','5C','4A','5C','4A','5D',
  '5E','5F','5E','5D','5C','5D','5C','5D',
  '5C','5D','5C','5D','5C','5D','5C','5E',

  '5D','4A','5D','4A','5C','4A','5C','4A',
  '5D','4A','5D','4A','5E','4A','5E','4A',
  '5C','4A','5C','4A','5D','4A','5D','4A',
  '5E','4A','5E','4A','5C','4A','5C','4A',

  '5D','5F','5D','5F','5C','5F','5C','5F',
  '5D','5F','5D','5F','5E','5F','5E','5F',
  '5C','5F','5C','5F','5D','5F','5D','5F',
  '5E','5F','5E','5F','5C','5F','5C','5F',

  '5D','5F','5D','5F','5E','5F','5E','5F',
  '5E','5F','5E','5F','5D','5F','5D','5F',
  '5C','5F','5C','5F','5D','5F','5D','5F',
  '5D','5F','5D','5F','5C','5F','5C','5F',

  '4A','5F','4A','5F','5C','5F','5C','5F',
  '5C','5F','5C','5F','4A','5F','4A','5F',
  '5C','5F','5C','5F','5D','5F','5D','5F',
  '5D','5F','5D','5F','5C','5F','5C','5F',

  '4A','5F','5E','5D','5C','5D','5E','5F',
  '5D','5F','5E','5D','5C','5D','5E','5F',
  '5D','5F','5E','5D','5C','5D','5E','5F',
  '5D','5F','5E','5D','5C','5D','5E','5F',

  '5D','4A','5C','5D','5E','5C','5D','5E',
  '5F','4A','5C','5D','5E','5C','5D','5E',
  '5F','4A','5C','5D','5E','5C','5D','5E',
  '5F','4A','5C','5D','5E','5C','5D','5E',

  '5F','5E','5D','5F','5E','5D','5E','5D',
  '5E','5D','5C','5E','5D','5C','5D','5C',
  '5D','5C','4A','5D','5C','4A','5C','4A',
  '5E','5D','5C','5E','5D','5C','5D','5C',

  '5D','5E','5F','5E','5D','5E','5D','5E',
  '5C','5D','5E','5D','5C','5D','5C','5D',
  '4A','5C','5D','5C','4A','5C','4A','5D',
  '5C','5D','5E','5D','5C','5D','5C','5E',
    //7
  '4A','5C','5D','5E','5Fs','5E','5D','5C',
  '4A','5C','5D','5E','5Fs','5E','5D','5C',
  '4A','5C','5D','5E','5Fs','5E','5D','5C',
  '4A','5C','5D','5E','5Fs','5E','5D','5C',

  '4A','5C','5D','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5D','5E','5D','4A',
  '5C','5D','5E','5Fs','5E','5Fs','5E','5Fs',
  '5E','5Fs','5E','5Fs','5E','5Fs','5E','5C',

  '5D','5C','5D','5E','5Fs','5E','5Fs','5E',
  '5Fs','5E','5Fs','5E','5Fs','5E','5Fs','5D',
  '5C','4A','5C','5D','5E','5D','5E','5D',
  '5E','5D','5E','5D','5E','5D','5E','5C',

  '5D','5E','5D','5C','4A','5C','4A','5C',
  '4A','5C','4A','5C','4A','5C','4A','5D',
  '5E','5Fs','5E','5D','5C','5D','5C','5D',
  '5C','5D','5C','5D','5C','5D','5C','5E',

  '5D','4A','5D','4A','5C','4A','5C','4A',
  '5D','4A','5D','4A','5E','4A','5E','4A',
  '5C','4A','5C','4A','5D','4A','5D','4A',
  '5E','4A','5E','4A','5C','4A','5C','4A',

  '5D','5Fs','5D','5Fs','5C','5Fs','5C','5Fs',
  '5D','5Fs','5D','5Fs','5E','5Fs','5E','5Fs',
  '5C','5Fs','5C','5Fs','5D','5Fs','5D','5Fs',
  '5E','5Fs','5E','5Fs','5C','5Fs','5C','5Fs',

  '5D','5Fs','5D','5Fs','5E','5Fs','5E','5Fs',
  '5E','5Fs','5E','5Fs','5D','5Fs','5D','5Fs',
  '5C','5Fs','5C','5Fs','5D','5Fs','5D','5Fs',
  '5D','5Fs','5D','5Fs','5C','5Fs','5C','5Fs',

  '4A','5Fs','4A','5Fs','5C','5Fs','5C','5Fs',
  '5C','5Fs','5C','5Fs','4A','5Fs','4A','5Fs',
  '5C','5Fs','5C','5Fs','5D','5Fs','5D','5Fs',
  '5D','5Fs','5D','5Fs','5C','5Fs','5C','5Fs',

  '4A','5Fs','5E','5D','5C','5D','5E','5Fs',
  '5D','5Fs','5E','5D','5C','5D','5E','5Fs',
  '5D','5Fs','5E','5D','5C','5D','5E','5Fs',
  '5D','5Fs','5E','5D','5C','5D','5E','5Fs',

  '5D','4A','5C','5D','5E','5C','5D','5E',
  '5Fs','4A','5C','5D','5E','5C','5D','5E',
  '5Fs','4A','5C','5D','5E','5C','5D','5E',
  '5Fs','4A','5C','5D','5E','5C','5D','5E',

  '5Fs','5E','5D','5Fs','5E','5D','5E','5D',
  '5E','5D','5C','5E','5D','5C','5D','5C',
  '5D','5C','4A','5D','5C','4A','5C','4A',
  '5E','5D','5C','5E','5D','5C','5D','5C',

  '5D','5E','5Fs','5E','5D','5E','5D','5E',
  '5C','5D','5E','5D','5C','5D','5C','5D',
  '4A','5C','5D','5C','4A','5C','4A','5D',
  '5C','5D','5E','5D','5C','5D','5C','5E',
   //8
  '4A','5Cs','5D','5E','5Fs','5E','5D','5Cs',
  '4A','5Cs','5D','5E','5Fs','5E','5D','5Cs',
  '4A','5Cs','5D','5E','5Fs','5E','5D','5Cs',
  '4A','5Cs','5D','5E','5Fs','5E','5D','5Cs',

  '4A','5Cs','5D','5E','5D','5E','5D','5E',
  '5D','5E','5D','5E','5D','5E','5D','4A',
  '5Cs','5D','5E','5Fs','5E','5Fs','5E','5Fs',
  '5E','5Fs','5E','5Fs','5E','5Fs','5E','5Cs',

  '5D','5Cs','5D','5E','5Fs','5E','5Fs','5E',
  '5Fs','5E','5Fs','5E','5Fs','5E','5Fs','5D',
  '5Cs','4A','5Cs','5D','5E','5D','5E','5D',
  '5E','5D','5E','5D','5E','5D','5E','5Cs',

  '5D','5E','5D','5Cs','4A','5Cs','4A','5Cs',
  '4A','5Cs','4A','5Cs','4A','5Cs','4A','5D',
  '5E','5Fs','5E','5D','5Cs','5D','5Cs','5D',
  '5Cs','5D','5Cs','5D','5Cs','5D','5Cs','5E',

  '5D','4A','5D','4A','5Cs','4A','5Cs','4A',
  '5D','4A','5D','4A','5E','4A','5E','4A',
  '5Cs','4A','5Cs','4A','5D','4A','5D','4A',
  '5E','4A','5E','4A','5Cs','4A','5Cs','4A',

  '5D','5Fs','5D','5Fs','5Cs','5Fs','5Cs','5Fs',
  '5D','5Fs','5D','5Fs','5E','5Fs','5E','5Fs',
  '5Cs','5Fs','5Cs','5Fs','5D','5Fs','5D','5Fs',
  '5E','5Fs','5E','5Fs','5Cs','5Fs','5Cs','5Fs',

  '5D','5Fs','5D','5Fs','5E','5Fs','5E','5Fs',
  '5E','5Fs','5E','5Fs','5D','5Fs','5D','5Fs',
  '5Cs','5Fs','5Cs','5Fs','5D','5Fs','5D','5Fs',
  '5D','5Fs','5D','5Fs','5Cs','5Fs','5Cs','5Fs',

  '4A','5Fs','4A','5Fs','5Cs','5Fs','5Cs','5Fs',
  '5Cs','5Fs','5Cs','5Fs','4A','5Fs','4A','5Fs',
  '5Cs','5Fs','5Cs','5Fs','5D','5Fs','5D','5Fs',
  '5D','5Fs','5D','5Fs','5Cs','5Fs','5Cs','5Fs',

  '4A','5Fs','5E','5D','5Cs','5D','5E','5Fs',
  '5D','5Fs','5E','5D','5Cs','5D','5E','5Fs',
  '5D','5Fs','5E','5D','5Cs','5D','5E','5Fs',
  '5D','5Fs','5E','5D','5Cs','5D','5E','5Fs',

  '5D','4A','5Cs','5D','5E','5Cs','5D','5E',
  '5Fs','4A','5Cs','5D','5E','5Cs','5D','5E',
  '5Fs','4A','5Cs','5D','5E','5Cs','5D','5E',
  '5Fs','4A','5Cs','5D','5E','5Cs','5D','5E',

  '5Fs','5E','5D','5Fs','5E','5D','5E','5D',
  '5E','5D','5Cs','5E','5D','5Cs','5D','5Cs',
  '5D','5Cs','4A','5D','5Cs','4A','5Cs','4A',
  '5E','5D','5Cs','5E','5D','5Cs','5D','5Cs',

  '5D','5E','5Fs','5E','5D','5E','5D','5E',
  '5Cs','5D','5E','5D','5Cs','5D','5Cs','5D',
  '4A','5Cs','5D','5Cs','4A','5Cs','4A','5D',
  '5Cs','5D','5E','5D','5Cs','5D','5Cs','5E',

];
export default shredieckNotes